import React from 'react';

import type { ChipProps } from '@mui/material';
import { alpha, Chip, Typography } from '@mui/material';
import clsx from 'clsx';
import { IconColors } from 'src/components/icons/icon-utils';
import { SmallXIcon } from 'src/components/icons/SmallXIcon';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<StyleProps>()((theme, { chipColor }) => ({
  chip: {
    backgroundColor: alpha(chipColor, 0.1),
    width: 'fit-content',
  },
  chipText: {
    color: chipColor,
    fontFamily: theme.typography.fontFamily,
    fontSize: 12,
    fontWeight: 600,
  },
  deletableChip: {
    '&:focus': {
      backgroundColor: alpha(chipColor, 0.2),
    },
  },
}));

type StyleProps = Required<Pick<SmallChipProps, 'chipColor'>>;

interface SmallChipProps extends ChipProps {
  text: string;
  chipColor?: string;
}

export function SmallChip({
  chipColor = IconColors.Primary,
  className,
  text,
  ...rest
}: SmallChipProps): JSX.Element {
  const { classes } = useStyles({ chipColor });

  return (
    <Chip
      className={clsx(className, classes.chip)}
      classes={{ deletable: classes.deletableChip }}
      deleteIcon={<SmallXIcon fill={chipColor} />}
      label={
        <Typography noWrap align="left" className={classes.chipText}>
          {text}
        </Typography>
      }
      size="small"
      {...rest}
    />
  );
}
